import Typography from '@mui/material/Typography'
import React from 'react'

import VideoPlayer from '@/app/component/atom/video-player'
import { TGetFileFunction } from '@/app/module/conversations/types'

type Props = {
  videoFile?: string
  message: string
  getFile: TGetFileFunction
}

const WhatsappVideo: React.FC<Props> = ({ videoFile, message, getFile }) => (
  <>
    {videoFile && <VideoPlayer filename={videoFile} getFile={getFile} />}
    <Typography style={{ whiteSpace: 'pre-line' }}>{message}</Typography>
  </>
)

export default WhatsappVideo
